import React from "react"
import { withFormsy } from "formsy-react"
import types from "prop-types"
import clsx from "clsx"
import InputErrorMessage from "shared/InputErrorMessage"

const TextInput = ({
  hasBaseInputStyle = true,
  ariaLabel = "",
  className = undefined,
  disabled = false,
  errorMessages = [],
  isPristine = true,
  isStatusValid = true,
  name = undefined,
  onBlur = () => {},
  onClick = () => {},
  onFocus = () => {},
  onChange = () => {},
  onKeyDown = () => {},
  placeholder = "",
  readonly = false,
  required = false,
  tabIndex = null,
  uuid = undefined,
  value = "",
  ref = undefined,
}) => (
  <>
    <input
      autoComplete="off"
      className={clsx(className, hasBaseInputStyle && "base-input")}
      disabled={disabled}
      id={uuid}
      name={name || uuid}
      onBlur={onBlur}
      onChange={({ target }) => onChange(target.value)}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onClick={onClick}
      placeholder={`${placeholder} ${required ? "*" : ""}`}
      ref={ref}
      tabIndex={tabIndex}
      readOnly={readonly}
      type="text"
      value={value}
      aria-label={ariaLabel}
    />
    <InputErrorMessage isStatusValid={isStatusValid} isPristine={isPristine} errorMessages={errorMessages} />
  </>
)

TextInput.propTypes = {
  hasBaseInputStyle: types.bool,
  ariaLabel: types.string,
  className: types.string,
  disabled: types.bool,
  errorMessages: types.arrayOf(types.string),
  isPristine: types.bool,
  isStatusValid: types.bool,
  name: types.string,
  onBlur: types.func,
  onClick: types.func,
  onFocus: types.func,
  onChange: types.func,
  onKeyDown: types.func,
  placeholder: types.string,
  readonly: types.bool,
  required: types.bool,
  tabIndex: types.string,
  uuid: types.string,
  value: types.string,
  ref: types.oneOfType([types.func, types.object]),
}

TextInput.displayName = "TextInput"

export const FormsyTextInput = withFormsy(({ setValue, inputRef, ...rest }) => (
  <TextInput
    ref={inputRef}
    onChange={(value) => setValue(value.trimStart())}
    {...rest}
  />
))

FormsyTextInput.displayName = "FormsyTextInput"

export default TextInput
